import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import * as LuIcons from 'react-icons/lu';
import SafeIcon from '../common/SafeIcon';

const { LuChevronRight, LuHome } = LuIcons;

export default function Breadcrumbs() {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);

  return (
    <nav className="flex items-center space-x-2 text-sm text-slate-500 dark:text-slate-400 mb-6">
      <Link to="/" className="hover:text-primary-600 transition-colors flex items-center gap-1">
        <SafeIcon icon={LuHome} size={14} />
        <span>Dashboard</span>
      </Link>
      
      {pathnames.map((name, index) => {
        const routeTo = `/${pathnames.slice(0, index + 1).join('/')}`;
        const isLast = index === pathnames.length - 1;
        const displayName = name.charAt(0).toUpperCase() + name.slice(1);

        // Skip the ID part in the breadcrumb display if it's a UUID
        const isUUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(name);
        if (isUUID) return null;

        return (
          <React.Fragment key={name}>
            <SafeIcon icon={LuChevronRight} size={14} className="text-slate-300" />
            {isLast ? (
              <span className="font-semibold text-slate-900 dark:text-white">{displayName}</span>
            ) : (
              <Link to={routeTo} className="hover:text-primary-600 transition-colors capitalize">
                {displayName}
              </Link>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
}